import moment, { Duration, DurationInputArg1, DurationInputArg2, Moment, unitOfTime } from "moment"
import { dateTypes, diffOptions, inputDateFormat } from "../../typescript/dates/date-models"

export const timestampHasDateTime = (timestamp: string): boolean => {
    if(!timestamp){
        return false
    }
    return timestamp.includes("T")
}

export const getCurrentTime = (format?: dateTypes) => {
    if(format){
        return moment().format(format)
    }
    return getNowNoFormat
}

export const getNowNoFormat = () => {
    return moment()
}

export const getDateFormattedAsMoment = (
    date: inputDateFormat,
    outputformat?: dateTypes,
    inputFormat?: dateTypes,
): string => {
    let output = outputformat ? outputformat : dateTypes.globalFilterDateFormat
    if(inputFormat){
        return getDateAsMoment(date, inputFormat).format(output)
    }
    return getDateAsMoment(date).format(output)
}

export const getDateAsMoment = (
    date: inputDateFormat, 
    inputFormat?: dateTypes
): Moment => {
    if(inputFormat){
        return moment(date, inputFormat)
    }
    return moment(date)
}

export const getDiffBetweenDates = (startDate: Moment, endDate: Moment, unitDifference?: unitOfTime.Diff): number => {
    if(unitDifference){
        return endDate.diff(startDate, unitDifference)
    }
    return endDate.diff(startDate)
}
export const getDiffToNow = (date, unitDifference: unitOfTime.Diff): number => {
    return moment().diff(date, unitDifference)
}

export const getDurationBetweenDates = (startDate: Moment, endDate: Moment): Duration => {
    return moment.duration(getDiffBetweenDates(startDate, endDate))
}

export const dateIsSameOrAfterSecond = (firstDate: Moment, secondDate: Moment, reverse?: boolean): boolean => {
    if(reverse){
        return secondDate.isSameOrAfter(firstDate);
    }
    return firstDate.isSameOrAfter(secondDate);
}

export const dateIsSameOrBefore = (firstDate: Moment, secondDate: Moment, reverse?: boolean): boolean => {
    if(reverse){
        return secondDate.isSameOrBefore(firstDate);
    }
    return firstDate.isSameOrBefore(secondDate);
}

export const dateIsSameToAnother = (firstDate: Moment, secondDate: Moment, reverse?: boolean): boolean => {
    if(reverse){
        return secondDate.isSame(firstDate);
    }
    return firstDate.isSame(secondDate);
}

export const dateIsAfterAnother = (firstDate: Moment, secondDate: Moment, reverse?: boolean): boolean => {
    if(reverse){
        return secondDate.isAfter(firstDate);
    }
    return firstDate.isAfter(secondDate);
}

export const addTimeToDate = (date: Moment, timeToAdd: DurationInputArg1, type?: DurationInputArg2): Moment => {
    if(type){
        return date.add(timeToAdd, type) 
    }
    return date.add(timeToAdd)
}

export const substractTimeToDate = (date: Moment, timeToSubstract: DurationInputArg1, type: DurationInputArg2): Moment => {
    return date.subtract(timeToSubstract, type)
}

export const timeIsValid = (time) => {
    return moment(time, dateTypes.hoursAndMinutesFormat, true);
}

export const getTimeDiff = (value, type: diffOptions) => {
    return addTimeToDate(getNowNoFormat(), value, type)  
}

export const getParseTime = (time) => {
    if (!time.match(/(\d+)/))
        return {
            measure: null,
            value: null
        };
    let timeValue = time.match(/(\d+)/)[0];
    let timeMeasure = time.substring(time.indexOf(' ') + 1);
    return {
        measure: timeMeasure,
        value: timeValue
    };
}

export const getMomentPlusTime = (time) => {
    if (!time) return null;
    let timeDiff = getParseTime(time);
    let value = timeDiff.value;
    let self = this;
    switch (timeDiff.measure) {
        case 'dias':
        case 'dia':
            return getTimeDiff(value, diffOptions.days);
        case 'horas':
        case 'hora':
            return getTimeDiff(value, diffOptions.hours);
        case 'minutos':
        case 'minuto':
           return getTimeDiff(value, diffOptions.minutes);
        case 'segundos':
        case 'segundo':
           return getTimeDiff(value, diffOptions.seconds);
    }
}

export const getUniqueDaysFromTimestampListParsed = (timestampList:Array<object>): string[] => {
    let uniqueDays:string[] = [];
    for (let index = 0; index < timestampList.length; index++) {
        const timestamp = timestampList[index]['timestamp'];
        const day = timestamp.slice(0, 10);
        if(uniqueDays.indexOf(day) == -1){
            uniqueDays.push(timestamp)
        }
    }
    if(uniqueDays.length > 0){
        uniqueDays = uniqueDays.map(function(uniqueDay){
            let date = new Date(uniqueDay);
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
            uniqueDay =`${day}/${month}/${year}`;
            return uniqueDay
        });
    }
    return uniqueDays
}

export const getMilisecondsFromTimestamp = (value:string) => {
    return new Date(value).getTime()
}





